import { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import xSvg from './assets/x.svg'



function Toast({ trigger, message, toastType = "warning" }) {

  useEffect(() => {
    if (trigger) {
      setTimeout(() => {
        showToast(message, toastType)
      }, 10)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger])

  function showToast(message) {
    const toast = document.getElementById('toast')
    if (!toast) {
      return
    }
    toast.getElementsByClassName("message")[0].innerHTML = message

    if (toast.style.display && toast.style.display !== "none") {
      return // already visible
    }

    toast.style.display = "flex"
    setTimeout(() => {
      toast.classList.add("fade")
      setTimeout(() => {
        toast.style.display = "none"
        toast.classList.remove("fade")
      }, 500)
    }, 3000)
  }

  function hideToast() {
    const toast = document.getElementById('toast')
    if (!toast) {
      return
    }
    toast.classList.remove("fade")
    toast.style.display = "none"
  }

  return (
    <>
      <Row className="d-flex justify-content-center">
        <Col className="col-auto position-fixed top-0 start-50 translate-middle-x p-3" style={{ zIndex: 11 }}>
          <Row id="toast" className={`toast hide bg-${toastType} border-${toastType}`} role="alert" aria-live="assertive" aria-atomic="true">
            <Col className="fs-5 d-flex justify-content-between">
              <span className="message fs-5 p-3"></span>
              <button type="button" onClick={hideToast} className={`btn btn-${toastType} fs-5 m-0 p-0`} data-bs-dismiss="toast" aria-label="Close"><img className="" style={{ width: "40px" }} src={xSvg} alt="close" /></button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default Toast